import { combineReducers } from 'redux'

import deleteNode from './diameters/delete'
import get from './diameters/get'
import list from './diameters/list'
import post from './diameters/post'
import put from './diameters/put'

export default combineReducers({
  delete: deleteNode,
  get,
  list,
  post,
  put
})



// WEBPACK FOOTER //
// ./src/reducers/root/entities/diameters.js